import script from "./CardComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardComponent.vue?vue&type=script&lang=ts&setup=true"

import "./CardComponent.vue?vue&type=style&index=0&id=45f54970&scoped=true&lang=css"

import exportComponent from "/home/node/skat32-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45f54970"]])

export default __exports__